import { flatten } from 'ramda'
import { Entity } from './types'

export const createDinamicColumnKey = (name: string, date: string) => {
  return `${name}_${date}`
}

export const extractDateAndNameFromColumnKey = (columnKey: string) => {
  return columnKey.split('_') as [string, string]
}

export const columnKeysLeft = [Entity.Title]
export const columnKeysLeftHeaders = [columnKeysLeft, [Entity.TitleGhost]]

export const columnKeysRight = [Entity.TotalCount, Entity.TotalSum]
export const columnKeysRightHeaders = [[Entity.Total], columnKeysRight]

export const createColumnKeysMain = (dates: Array<string>) => {
  return flatten(
    dates.map((date) => [
      createDinamicColumnKey(Entity.DateCount, date),
      createDinamicColumnKey(Entity.DateSum, date),
    ]),
  )
}

export const createColumnKeysMainHeaders = (dates: Array<string>) => {
  return [
    dates.map((date) => createDinamicColumnKey(Entity.Date, date)),
    createColumnKeysMain(dates),
  ]
}
